module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "layer-container"
  }, [_c('div', {
    staticClass: "layer-box"
  }, [_c('h3', {
    staticClass: "layer-title box"
  }, [_c('p', {
    staticClass: "box-flex"
  }, [_vm._v(_vm._s(_vm.title))]), _c('p', [_c('a', {
    staticClass: "icon-close",
    on: {
      "click": _vm.handleCancel
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "layer-content"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('h6', {
    staticClass: "layer-btns  fx fx-y-center fx-x-right"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCancel),
      expression: "isCancel"
    }],
    staticClass: "z-btn z-btn-default b-r-3 m-r-20",
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v(_vm._s(_vm.cancelTitle))]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOk),
      expression: "isOk"
    }],
    staticClass: "z-btn z-btn-primary b-r-3 m-r-20",
    on: {
      "click": _vm.handleOk
    }
  }, [_vm._v(_vm._s(_vm.okTitle))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-05d17dbe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/zui/LayersMaterial.vue
// module id = 807
// module chunks = 0